import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { AsOfDateComponent } from './as-of-date.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatMomentDateModule } from '@angular/material-moment-adapter';

@NgModule({
    imports: [
        SharedModule,
        MatDatepickerModule,
        MatMomentDateModule,
        MatFormFieldModule,
        MatInputModule,
    ],
    declarations: [AsOfDateComponent],
    exports: [AsOfDateComponent],
})
export class AsOfDateModule
{
}
